<template lang="html">
  <div>
    <div class="gap-9x" />
    <h3>{{title}}</h3>
    <div class="gap-3x" />
    <div class="line-break-gray" />
    <div class="gap-3x" />
    <slot />
  </div>
</template>

<script>
export default {
  props: ["title"]
}
</script>

<style lang="css" scoped>
</style>
